import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ErrorLike } from '@apollo/client';
import { Task } from 'graphql-common';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import TaskReportingView from './TaskReportingView/TaskReportingView';

type Props = {
  taskData?: Task;
  taskError?: ErrorLike;
  taskLoading?: boolean;
};

export default function TaskReportingViewContainer(props: Props) {
  const { taskData, taskError, taskLoading } = props;
  const { id } = useParams();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <BreadCrumbs
        data={getBreadCrumbsDataByKey({ pathname, t, entity: taskData })}
      />
      <TaskReportingView
        task={taskData}
        taskError={taskError}
        taskId={id}
        taskLoading={taskLoading}
      />
    </>
  );
}
